

<div class="registered-row" style="margin-left: 40px; margin-top: 20px;">
    <h2 class="title">Totems Cadastrados</h2>
    <button *ngIf="mode === 'all'" (click)="newForm()" style="float: right;" mat-raised-button class="mt-3 new-panel-btn">
        Novo Totem
        <mat-icon>add_circle</mat-icon>
    </button>
</div>
<div style="margin: 40px; margin-top: 20px;">
    <div class="card">
        <table *ngIf="mode==='all'" mat-table [dataSource]="totems" class="demo-table">
            <ng-container matColumnDef="nome" sticky>
                <th mat-header-cell *matHeaderCellDef> Nome </th>
                <td style="width: 35%" mat-cell *matCellDef="let element"> {{element.nome}} </td>
            </ng-container>
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef> ID </th>
                <td style="width: 30%" mat-cell *matCellDef="let element">
                    {{element.id}} </td>
            </ng-container>
            <ng-container matColumnDef="prefixo">
                <th mat-header-cell *matHeaderCellDef> Prefixo </th>
                <td style="width: 30%" mat-cell *matCellDef="let element">
                    {{element.prefixo}}
                </td>
            </ng-container>
            <ng-container matColumnDef="edit" stickyEnd>
                <th mat-header-cell *matHeaderCellDef></th>
                <td style="width: 5%" mat-cell *matCellDef="let element; let i = index">
                    <button (click)="newForm(i)" style="margin:10px" mat-raised-button class="purple-btn">
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button [disabled]="showSpinner ? true : false" (click)="deleteTotem(element.id)"
                        style="margin:10px" mat-raised-button class="gray-btn" color="accent">
                        <mat-spinner diameter='18' [style.display]="showSpinner ? 'inline-block' : 'none'">
                        </mat-spinner>
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>


                
        <mat-tab-group *ngIf="mode === 'form'" class="mt-5" dynamicHeight [(selectedIndex)]="tabGroupIndex">
            <mat-tab label="Dados Gerais do Totem">
                <div layout="row" layout-padding>
                    <div class="flex" flex="20"></div>
                </div>
                <form [formGroup]="formTotem" style="margin: 50px">
                    <div>
                        <mat-form-field>
                            <mat-label>Nome</mat-label>
                            <input type="text" required formControlName=nome matInput>
                            <mat-error *ngIf="formTotem.get('nome')?.hasError('required')">
                                O nome é obrigatório
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field>
                            <mat-label>Prefixo</mat-label>
                            <input type="text" formControlName=prefixo matInput>
                            <mat-error *ngIf="formTotem.get('prefixo')?.hasError('maxlength')">
                                O prefixo deve ter no máximo 3 caracteres
                                (atual: {{ formTotem.get('prefixo')?.errors?.maxlength?.actualLength }})
                            </mat-error>
                        </mat-form-field>
                    </div>
                </form>
                <!-- <button style="margin-left: 10%" (click)="cleanForm()" [disabled]="showSpinner ? true : false"
                    mat-raised-button color="clean">
                    <mat-spinner diameter='18' [style.display]="showSpinner ? 'inline-block' : 'none'">
                    </mat-spinner> Voltar
                </button>

                <button [disabled]="showSpinner ? true : false" style="margin-left: 1%" (click)="submitForm()"
                    type="submit" mat-raised-button color="primary">
                    <mat-spinner diameter='18' [style.display]="showSpinner ? 'inline-block' : 'none'">
                    </mat-spinner>Concluído
                </button> -->
            </mat-tab>
            <mat-tab label="Dados dos Paineis">
                <!-- Warning for no panels -->
                <div *ngIf="showPainelWarning" class="ui warning message" style="margin: 20px; padding: 15px; background-color: #fff6f6; color: #9f3a38; border: 1px solid #e0b4b4; border-radius: 4px;">
                    <div style="font-weight: bold; margin-bottom: 5px;">Atenção!</div>
                    <p>Nenhum painel foi selecionado para este Totem. É necessário adicionar pelo menos um painel.</p>
                </div>
                
                <!-- Warning for multiple panels -->
                <div *ngIf="showMultiplePainelWarning" class="ui warning message" style="margin: 20px; padding: 15px; background-color: #fff6f6; color: #9f3a38; border: 1px solid #e0b4b4; border-radius: 4px;">
                    <div style="font-weight: bold; margin-bottom: 5px;">Atenção!</div>
                    <p>Múltiplos painéis foram selecionados para este Totem. Recomenda-se utilizar apenas um painel por Totem.</p>
                </div>
                
                <h2 class="wwTitle mt-5">
                    Paineis do Totem

                    <button *ngIf="totemPainelMode === 'all' " (click)="newTotemPainelForm()" style="float: right;"
                        mat-raised-button style="background-color: green; color:white;"> Novo Painel
                        <mat-icon>add_circle</mat-icon>
                    </button>
                </h2>
                <div *ngIf="totemPainelMode === 'form'">
                    <button style="margin-left: 10%" (click)="cleanTotemPainelForm()"
                    [disabled]="showSpinner ? true : false" mat-raised-button color="clean">
                    <mat-spinner diameter='18' [style.display]="showSpinner ? 'inline-block' : 'none'">
                    </mat-spinner> Cancelar
                </button>

                <button [disabled]="showSpinner ? true : false" style="margin-left: 1%"
                    (click)="submitTotemPainelForm()" type="submit" mat-raised-button color="primary">
                    <mat-spinner diameter='18' [style.display]="showSpinner ? 'inline-block' : 'none'">
                    </mat-spinner>Inserir Painel
                </button>
                </div>
                <table *ngIf="totemPainelMode==='all'" mat-table [dataSource]="totemPaineis"
                    class="mat-elevation-z8 demo-table">
                    <ng-container matColumnDef="painelnome" sticky>
                        <th mat-header-cell *matHeaderCellDef> Painel </th>
                        <td style="width: 35%" mat-cell *matCellDef="let element"> {{element.painelnome ?
                            element.painelnome : getPainelName(element.painelid)!.nome}} </td>
                    </ng-container>
                    <ng-container matColumnDef="edit" stickyEnd>
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td style="width: 5%" mat-cell *matCellDef="let element; let i = index">
                            <button *ngIf="totem.id" (click)="newTotemPainelForm(i)" style="margin:10px"
                                mat-raised-button color="primary">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <button [disabled]="showSpinner ? true : false" (click)="deleteTotemPainel(i)"
                                style="margin:10px" mat-raised-button color="accent">
                                <mat-spinner diameter='18' [style.display]="showSpinner ? 'inline-block' : 'none'">
                                </mat-spinner>
                                <mat-icon>delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumnsPainel"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsPainel;"></tr>
                </table>
                <div *ngIf="totemPainelMode === 'form'">
                    <form [formGroup]="formTotemPainel" style="margin: 50px">
                        <div style="margin: 50px">
                            <mat-form-field>
                                <mat-label>Paineis</mat-label>
                                <mat-select formControlName="painelid" style="height: 20px !important;" required>
                                    <mat-option *ngFor="let i = index; let painel of paineis;" [value]="painel.id">
                                        {{painel.nome}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </form>
                </div>
            </mat-tab>
            <mat-tab label="Setores deste totem">
                <app-totem-setores [totemId]="totem.id"></app-totem-setores>
            </mat-tab>
        </mat-tab-group>

        <div *ngIf="mode==='form'">
            <button (click)="cleanForm()" [disabled]="showSpinner ? true : false"
                mat-raised-button class="gray-btn">
                <mat-spinner diameter='18' [style.display]="showSpinner ? 'inline-block' : 'none'">
                </mat-spinner> Voltar
            </button>

            <button [disabled]="showSpinner ? true : false" style="margin-left: 1%" (click)="submitForm()" type="submit"
                mat-raised-button class="purple-btn">
                <mat-spinner diameter='18' [style.display]="showSpinner ? 'inline-block' : 'none'">
                </mat-spinner>Concluído
            </button>
        </div>
    </div>
</div>
